(function () {
  var CONFIG = {
    testName: 'desconto_reais',
    contentScript: 'lov_abtesting_content.js',
    contentVersion: '6',
    splitB: 0.5,
    cookieDays: 30,
    antiflicker: true,
    antiflickerTimeout: 500,
    forceParam: 'lovab_force',
    eventName: 'teste_ab',
    cookiePrefix: 'lovab_'
  };

  var ran = window.__lovABTests || (window.__lovABTests = {});
  if (!CONFIG.testName || ran[CONFIG.testName]) {
    return;
  }
  ran[CONFIG.testName] = true;

  var cookieName = CONFIG.cookiePrefix + CONFIG.testName;
  var revealTimer = null;

  function readCookie(name) {
    var pattern = new RegExp('(?:^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)');
    var match = document.cookie.match(pattern);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function pushEvent(version) {
    var payload = {
      teste_ab_name: CONFIG.testName,
      teste_ab_version: version
    };

    function publish() {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(CONFIG.eventName, payload);
        console.log('publish', 'eventName', CONFIG.eventName, 'payload', payload);
        return true;
      }
      return false;
    }

    if (publish()) {
      return;
    }

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (publish() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  function hidePage() {
    if (document.getElementById('lovab-antiflicker')) {
      return;
    }
    var style = document.createElement('style');
    style.id = 'lovab-antiflicker';
    style.appendChild(document.createTextNode('html{opacity:0 !important}'));
    (document.head || document.documentElement).appendChild(style);
  }

  function revealPage() {
    if (revealTimer) {
      window.clearTimeout(revealTimer);
      revealTimer = null;
    }
    var style = document.getElementById('lovab-antiflicker');
    if (style && style.parentNode) {
      style.parentNode.removeChild(style);
    }
  }

  function whenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function contentSrc() {
    var base = document.currentScript && document.currentScript.src;
    if (!base) {
      return '';
    }
    var url = new URL(CONFIG.contentScript, base);
    url.searchParams.set('v', CONFIG.contentVersion);
    return url.href;
  }

  function loadContent() {
    var src = contentSrc();
    if (!src) {
      revealPage();
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.onload = function () {
      whenReady(function () {
        if (typeof window.LovABTestContent === 'function') {
          window.LovABTestContent(CONFIG);
        }
        window.setTimeout(revealPage, 0);
      });
    };
    script.onerror = revealPage;
    (document.head || document.documentElement).appendChild(script);
  }

  var forced = new URLSearchParams(window.location.search).get(CONFIG.forceParam);
  var isForce = forced === 'a' || forced === 'b';
  var version;

  if (isForce) {
    version = forced;
  } else {
    var stored = readCookie(cookieName);
    if (stored === 'a' || stored === 'b') {
      version = stored;
    } else {
      version = Math.random() < CONFIG.splitB ? 'b' : 'a';
      writeCookie(cookieName, version, CONFIG.cookieDays);
    }
    pushEvent(version);
  }

  if (version !== 'b') {
    return;
  }

  if (CONFIG.antiflicker) {
    hidePage();
    revealTimer = window.setTimeout(revealPage, CONFIG.antiflickerTimeout);
  }

  loadContent();
})();
